import Signal from "signals";
import { writable } from "svelte/store";
import GeoHelper from "../Helpers/GeoHelper";
import MapStore from "../Map/Store"; // TODO: only use MapHelpers
import BaseModel from "./BaseModel";
import ImageGeometryType from "./Enums/ImageGeometryType";

class Image extends BaseModel {
	constructor(data) {
		super({}, Image.defaults);
		this.data = data;

		this.collection = null;
		this.loaded = false;
		this.opacity = writable(1.0);
		this.visible = writable(false);
		this.events = {
			onLoaded: new Signal()
		};
	}

	isNew() {
		return (typeof this.id === "undefined") || this.id === -1;
	}

	get layerId() {
		if (this.collection !== null) {
			return "image_" + this.collection.id + "_" + this.id;
		}
		return "image_" + this.id;
	}

	get id() {
		return this.get("id");
	}

	get name() {
		return this.get("name");
	}

	get fileName() {
		return this.get("file_name");
	}

	get fileType() {
		return this.get("file_type");
	}

	get readableSize() {
		return this.get("size_bytes") + " bytes";
	}

	get width() {
		return this.get("size_pixels")[0];
	}

	get height() {
		return this.get("size_pixels")[1];
	}

	get geometryType() {
		return this.get("geometry_type");
	}

	get extent() {
		return this.get("extent");
	}

	get quad() {
		return this.get("quad");
	}

	get quadFromExtent() {
		return GeoHelper.calcQuadFromExtent(this.get("extent"));
	}

	get coords() {
		if (this.isQuad()) {
			return [
				this.quad[3], // flip it up the right way!
				this.quad[2],
				this.quad[1],
				this.quad[0]
			];
		}
		return MapStore.helpers.generateRectCoordsFromExtent(this.extent);
	}

	get properties() {
		return this.get("properties");
	}

	get url() {
		const temp = this.get("url");
		if (temp.length === 0) {
			return "";
		}
		return temp;
	}

	generatePresignedUrl() {
		// TODO: if needed
	}

	isQuad() {
		return this.geometryType === ImageGeometryType.QUAD;
	}

	isQuadSet() {
		return GeoHelper.isNonZeroQuad(this.quad);
	}

	isExtent() {
		return this.geometryType === ImageGeometryType.EXTENT;
	}

	isExtentSet() {
		return GeoHelper.isNonZeroExtent(this.extent);
	}

	get ownerUserId() {
		return this.get("owner_user_id");
	}

	get ownerUserName() {
		return this.get("owner_user_name");
	}

	update(data) {
		super.setData(data);
	}
}
Image.defaults = { // Defaults
	id: -1,
	name: "",
	file_name: "",
	file_type: "",
	size_bytes: 0,
	size_pixels: [0, 0],
	url: "",
	geometry_type: ImageGeometryType.EXTENT,
	extent: [0, 0, 0, 0],
	quad: [[0, 0], [0, 0], [0, 0], [0, 0]],
	properties: {},
	owner_user_id: 0,
	owner_user_name: ""
};

export default Image;
